import { render } from "./view_single_asset.html?vue&type=template&id=52a56b73&external"
import script from "./view_single_asset.js?vue&type=script&lang=js&external"
export * from "./view_single_asset.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__